export default __webpack_public_path__ + "static/media/live-pro.7dfe9d45.png";